import * as XLSX from 'xlsx';


export const convertFileToListOfData = (file: any):Promise<string[]> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        reader.onload = (e: any) => {
            /* Parse data */
            const bstr = e.target.result;
            const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
            /* Get first worksheet */
            const sheetName = wb.SheetNames[0];
            const ws = wb.Sheets[sheetName];
            /* Convert array of arrays */
            const data: Array<Array<string>> = XLSX.utils.sheet_to_json(ws, { header: 1 });
            const finalData: string[] = [];
            data.forEach((row: string[] | number[], id: number) => {
                if (id > 0 && row.length >0 && row[0]!== undefined && (typeof row[0] === "string" || typeof row[0] ==="number")){
                    if(typeof row[0] == "string") finalData.push(row[0]);
                    else finalData.push(row[0].toString());
                }
            })
            /* Update state */
            resolve(finalData);
        };

        reader.onerror = (error) => {
            reject(error);
        }

        if (rABS && file) reader.readAsBinaryString(file);
        else if (file) reader.readAsArrayBuffer(file);
    })
}